import { useMemo, useState } from 'react'
import type { BounceProps } from '../types/bounce-types'
import { BuiltIn } from '../utilities/bezier-plugin'
import { useInputContext, useInputSetters, Components } from 'leva/plugin'
import { StyledButton } from '../styles/StyledButton'
import { StyledIcons } from '../styles/StyledIcons'
import { StyledReturnButton } from '../styles/StyledReturnButton'
import { useGlobalState } from '../hooks/useGlobalState'
import { BezierProps } from '../types/bezier-types';
import { StyledSVGOffset } from '../styles/StyledSVGOffset'
import TopSection from './TopSection'
import {version} from '../../../package.json'

const { Row, Vector, Select } = Components
const optionKeys = ['custom', ...Object.keys(BuiltIn)]
const optionValues = [false, ...Object.values(BuiltIn).map((c) => c.toString())]
const selectSettings = { keys: optionKeys, values: optionValues }

function SelectBezier({ value, onUpdate }: Pick<BounceProps, 'value' | 'onUpdate'>) {
  const selectValue = useMemo(() => optionValues.find((v) => v === value.toString()) || false, [value])
  const args = { type: 'SELECT', value: selectValue, settings: selectSettings }
  const setValue = (newValue: string | boolean) => newValue && onUpdate((newValue as string).split(','))
  const select = useInputSetters({ ...args, setValue })
  return (
    <Select
      value={selectValue}
      displayValue={select.displayValue}
      onUpdate={select.onUpdate}
      settings={selectSettings}
    />
  )
}

export function ConfigPanel() {
  const { value, label, displayValue, onUpdate, onChange, settings } = useInputContext<BounceProps>()
  const { dispatch, UIStatus, configSettings } = useGlobalState()
  const [ keyframeCollisionSetting, setKeyframeCollisionSetting ] = useState(configSettings.keyframeCollisionBehavior ? configSettings.keyframeCollisionBehavior : 'overwrite')
  const [ keyframeWriteAtTimeSetting, setKeyframeWriteAtTimeSetting ] = useState(configSettings.keyframeWriteAtTimeBehavior ? configSettings.keyframeWriteAtTimeBehavior : 'accurate')

  function handleKeyframeCollisionChange(e: any) : void {
    setKeyframeCollisionSetting(e.target.value)
  }

  function handleKeyframeWriteAtTimeChange(e: any) : void {
    setKeyframeWriteAtTimeSetting(e.target.value)
  }

  function handleConfigSave() : void {
    dispatch({ type: 'configSettings', payload: { keyframeCollisionBehavior: keyframeCollisionSetting,
                                                  keyframeWriteAtTimeBehavior: keyframeWriteAtTimeSetting }})
  }

  function keyframeCollisionHighlightValue(button: string) : string {
    if (keyframeCollisionSetting == 'overwrite' && button == 'overwrite') {
      return 'black'
    } else if (keyframeCollisionSetting == 'stop' && button == 'stop') {
      return 'black'
    } else {
      return '#272727'
    }
  }

  function keyframeWriteAtTimeHighlightValue(button: string) : string {
    if (keyframeWriteAtTimeSetting == 'nearest_frame' && button == 'nearest_frame') {
      return 'black'
    } else if (keyframeWriteAtTimeSetting == 'accurate' && button == 'accurate') {
      return 'black'
    } else {
      return '#272727'
    }
  } 
  console.log(`keyframeCollisionSetting: ${keyframeCollisionSetting} keyframeWriteAtTimeSetting: ${keyframeWriteAtTimeSetting}`)
  return (
  <>
    <TopSection/>
      <div style={{width: '100%', textAlign: 'center', marginTop:'20px', color:'#9e9e9e', fontSize: '14px'}}>Version: {version}</div>
    <Row style={{gridTemplateColumns:'50% auto', padding:"5vh 5vh 5vh 0"}}>
      <div style={{padding:'0 5vh 0 5vh'}}>Keyframe collision behavior</div>
      <div onChange={handleKeyframeCollisionChange} style={{display:'grid', gridTemplateColumns:'50% 50%', width:'100%'}}>
          <StyledButton onClick={handleKeyframeCollisionChange} style={{backgroundColor: keyframeCollisionHighlightValue('overwrite'), marginRight: '1rem'}} value="overwrite">Overwrite</StyledButton>
          <StyledButton onClick={handleKeyframeCollisionChange} style={{backgroundColor: keyframeCollisionHighlightValue('stop')}} value="stop">Stop</StyledButton>
      </div>
      <div style={{padding:'0 5vh 0 5vh'}}>Keyframe placement</div>
      <div onChange={handleKeyframeCollisionChange} style={{display:'grid', gridTemplateColumns:'50% 50%', width:'100%'}}>
          <StyledButton onClick={handleKeyframeWriteAtTimeChange} style={{backgroundColor: keyframeWriteAtTimeHighlightValue('nearest_frame'), marginRight: '1rem'}} value="nearest_frame">Frame</StyledButton>
          <StyledButton onClick={handleKeyframeWriteAtTimeChange} style={{backgroundColor: keyframeWriteAtTimeHighlightValue('accurate')}} value="accurate">Accurate</StyledButton>
      </div>
    </Row>
    <Row input style={{gridTemplateColumns:'56% auto', padding:"8px 0 10px 0"}}>
      {/* <div></div>
      <StyledButton onClick={() => requestToolSwitch('elastic')}>Elastic</StyledButton>
      <StyledButton onClick={() => requestToolSwitch('bounce')} style={{backgroundColor:"#181c20", borderColor: 'white'}}>Bounce</StyledButton> */}
       <StyledReturnButton onClick={handleConfigSave}>SAVE</StyledReturnButton>
    </Row>
  </>
  )
}